/* eslint max-lines: 0 */
import {
  _CreditListLinks,
  _SocietyLinks,
  Credit,
  FetchDDLResponse,
  Link,
  Society,
  SocietyAffiliation,
} from 'types/api.types';
import {
  _IpiListLinks,
  Ipi,
  IpiSearchCreatorOption,
  IpiValidations,
} from 'types/ipi.types';
import { apiUrls } from 'app/api.config';
import { ContributionFormData } from 'app/components/Song/Contributions/ContributionForm/types';
import { ProfileFormData } from 'app/components/Profile/ProfileForm/types';
import { alertsInitialState } from 'app/store/Alerts/slice';
import { authInitialState } from 'app/store/Auth/slice';
import { countriesInitialState } from 'app/store/Countries/slice';
import { AppState } from 'app/store';
import { settingsInitialState } from 'app/store/Settings/slice';
import { songListInitialState } from 'app/store/SongList/slice';
import { contributionsInitialState } from 'app/store/Contributions/slice';
import {
  audioPlayerInitialState,
  PlaylistDetails,
} from 'app/store/AudioPlayer/slice';
import { _IpnListLinks, Ipn, IpnValidations } from 'types/ipn.types';
import {
  Collaborator,
  CollaboratorPermission,
  CollaboratorStatus,
  InviteCollaboratorsPayload,
} from 'types/collaborator.types';
import {
  _SongLinks,
  _SongsLinks,
  Song,
  SongDDL,
  SongStatusType,
} from 'types/song';
import { releasesInitialState } from 'app/store/Releases/slice';
import { sharesInitialState } from 'app/store/Shares/slice';
import {
  Release,
  ReleaseSong,
  ReleaseType,
  ReleaseVersion,
  ReleaseVersionMetadata,
  ReleaseVersionSong,
  SoundCloudVersion,
  UpdateReleaseSongTitleValidations,
  UpdateReleaseValidations,
  UpdateReleaseVersionValidations,
  UpdateVersionSongValidations,
  Version,
} from 'types/releases';
import {
  _NotificationListLinks,
  Notification,
  SearchableProfile,
} from 'types/notification.types';
import { _InviteLinks, _InvitesListLinks, Invite } from 'types/invite.types';
import {
  _ProfileListLinks,
  Connection,
  Profile,
  ProfileAddress,
  ProfileCard,
  ProfileItem,
  ProfileType,
  Representative,
  SearchProfilesValidationProperties,
} from 'types/profile';
import { profileInitialState } from 'app/store/Profile/slice';
import { notificationsInitialState } from 'app/store/Notifications/slice';
import { electronInitialState } from 'app/store/Electron/slice';
import { intercomInitialState } from 'app/store/Intercom/slice';
import { webSocketsInitialState } from 'app/store/WebSockets/slice';
import { _IsniListLinks, Isni } from 'types/isni.types';
import { LatestSplit } from 'types/splits.types';
import {
  _LyricsLinks,
  LyricsData,
  LyricValidationSchema,
  LyricSheet2,
} from 'types/lyrics.types';
import { mixpanelInitialState } from 'app/store/Mixpanel/slice';
import { subscriptionInitialState } from 'app/store/Subscription/slice';
import { globalSearchInitialState } from 'app/store/GlobalSearch/slice';
import { storageInitialState } from 'app/store/Storage/slice';
import { PricingPlan, Subscription, Tier } from 'types/subscription.types';
import {
  _AudioLinks,
  Audio,
  AudioFormValidationProperties,
  AudioStatusReasonType,
  AudioStatusType,
  AudioTypesDDL,
} from 'types/audio';
import {
  _ContributionsLinks,
  Contribution,
  ContributionClassesAndRolesDDL,
  ContributionClassName,
  ContributionClassRolesDDL,
  ContributionValidationSchema,
  Contributor,
  WriterRole,
} from 'types/contribution';
import {
  Country,
  DDL,
  NumberValidation,
  Option,
  Settings,
  StringValidation,
  Time,
} from 'types/general.types';
import { BootstrapPayload, BootstrapServices } from 'types/bootstrap';
import { EntityType, ProfileImageSize } from 'types/enums';
import { Account, PasswordPolicy, SignUpData } from 'types/auth';
import { playlistsInitialState } from 'app/store/Playlists/slice';
import { AudioPlayerAudioInstance } from 'app/store/AudioPlayer/slice.types';
import { AudioSelectionItem } from 'app/components/Audio';
import {
  Playlist,
  PlaylistAudio,
  PlaylistsListItem,
} from 'types/playlists.types';
import { chatInitialState } from 'app/store/Chat/slice';
import {
  ChatChannelListItem,
  ChatMessageItem,
  MessageType,
} from 'types/chat.types';
import { importInitialState } from 'app/store/Import/slice.utils';

export const TEST_ID_LOADING_INDICATOR = 'loading-indicator';

export const appStateMock: AppState = {
  contributions: contributionsInitialState,
  songList: songListInitialState,
  settings: settingsInitialState,
  profile: profileInitialState,
  alerts: alertsInitialState,
  auth: authInitialState,
  electron: electronInitialState,
  countries: countriesInitialState,
  notifications: notificationsInitialState,
  audioPlayer: audioPlayerInitialState,
  releases: releasesInitialState,
  shares: sharesInitialState,
  intercom: intercomInitialState,
  webSockets: webSocketsInitialState,
  mixpanel: mixpanelInitialState,
  subscription: subscriptionInitialState,
  globalSearch: globalSearchInitialState,
  storage: storageInitialState,
  playlists: playlistsInitialState,
  chat: chatInitialState,
  import: importInitialState,
};

export const time: Time = {
  iso: '2021-04-22T13:32:46.730Z',
  timestamp: 1619098366,
};

export const href: Link = {
  href: apiUrls.songs,
  method: 'GET',
  scope: 'browser',
  templated: false,
};

export const stringValidation: StringValidation = {
  maxLength: 255,
  minLength: 1,
};

export const numberValidation: NumberValidation = {
  minimum: 1,
  maximum: 999,
};

export const contributor: Contributor = {
  guid: 'CNT_NvoLEO12re6xlj',
  parent: 'SNG_NvoLEO12re6xlj',
  created: {
    timestamp: 1620708716,
    iso: '2021-05-11T04:51:56.574Z',
  },
  updated: {
    timestamp: 1620708716,
    iso: '2021-05-11T04:51:56.574Z',
  },
  className: ContributionClassName.SONGWRITER,
  name: 'Nellie Junter',
  ipiNumber: '15690197',
  ipnNumber: '481231489',
  isniNumber: '1589 1896 8846 1432',
  email: 'akki.sin@jancokcp.com',
  writerRole: WriterRole.AUTHOR,
  initials: 'NJ',
};

export const contribution: Contribution = {
  guid: 'CNT_NvoLEO12re6xlj',
  parent: 'SNG_NvoLEO12re6xlj',
  created: {
    timestamp: 1620708716,
    iso: '2021-05-11T04:51:56.574Z',
  },
  createdBy: {
    profileCard: {
      displayName: 'name',
      guid: 'string',
      profileImages: [],
      initials: 'N',
      subject: 'string',
    },
  },
  updated: {
    timestamp: 1620708716,
    iso: '2021-05-11T04:51:56.574Z',
  },
  className: ContributionClassName.ARTIST,
  name: 'Nellie Junter',
  ipi: 123456789,
  role: 'Featuring',
};

export const _contributionsLinks: _ContributionsLinks = {
  self: href,
  countryCodesAlpha2DDL: href,
  deleteContribution: href,
  getContribution: href,
  updateContribution: href,
};

export const collaborator: Collaborator = {
  permission: CollaboratorPermission.ROOT,
  userGuid: 'user-guid',
  profile: {
    displayName: 'Philip Reek',
    initials: 'P',
    guid: 'guid',
  } as Profile,
  isSelf: true,
  status: CollaboratorStatus.ACCEPTED,
  created: time,
  _links: {
    deleteCollaborator: href,
  },
};

export const newCollaborator: Collaborator = {
  permission: CollaboratorPermission.ADMIN,
  userGuid: 'user-guid-2',
  profile: {
    displayName: 'Blake John',
    initials: 'BJ',
    guid: 'guid-2',
  } as Profile,
  isSelf: false,
  status: CollaboratorStatus.ACCEPTED,
  created: time,
};

export const inviteCollaboratorsPayload: InviteCollaboratorsPayload = {
  inviteeUserGuids: [{ guid: 'guid', inviteType: 'Suggestions' }],
  message: 'Join my song',
  permission: CollaboratorPermission.ADMIN,
};

export const _songLinks: _SongLinks = {
  self: href,
  updateSong: href,
  createContribution: href,
  listContributions: href,
  getContribution: href,
  deleteContribution: href,
  updateContribution: href,
  createAudio: href,
  deleteAudio: href,
  downloadAudio: href,
  listAudio: href,
  updateAudio: href,
  getAudioStatus: href,
  getAudio: href,
  inviteCollaborator: href,
  getMyContributionCheckInCode: href,
  createContributionCheckInCode: href,
  playLatestVersion: href,
  putLatestVersion: href,
  deleteLatestVersion: href,
  listLyricSheets: href,
};

export const _audioLinks: _AudioLinks = {
  upload: href,
  self: href,
  play: href,
};

export const profileCard: ProfileCard = {
  guid: '3333',
  initials: 'JC',
  displayName: 'John Cena',
  subject: '4444',
};

export const profileCardWithImage: ProfileCard = {
  guid: '3333',
  initials: 'JC',
  displayName: 'John Cena',
  firstName: 'John',
  lastName: 'Cena',
  subject: '4444',
  profileImages: [
    {
      name: ProfileImageSize.AVATAR_TINY,
      href:
        'https://www.whatsappprofiledpimages.com/wp-content/uploads/2021/08/Profile-Photo-Wallpaper.jpg',
    },
    {
      name: ProfileImageSize.AVATAR_SMALL,
      href:
        'https://www.whatsappprofiledpimages.com/wp-content/uploads/2021/08/Profile-Photo-Wallpaper.jpg',
    },
  ],
};

export const audio: Audio = {
  guid: 'audio-guid',
  parent: 'audio-parent-guid',
  createdBy: {
    guid: 'creator-guid',
    profileCard: {
      ...profileCard,
      displayName: 'display-name',
      initials: 'C',
    },
  },
  isPrivate: false,
  isLatestVersion: false,
  isMine: true,
  originalFilename: 'file-name.mp3',
  remark: 'note',
  status: AudioStatusType.READY_FOR_UPLOAD,
  statusReason: AudioStatusReasonType.READY_FOR_UPLOAD,
  title: 'audio-title',
  type: 'Bounce',
  created: time,
  updated: time,
  duration: 121515000,
  fileSize: 1561232,
  file: {} as File,
  _links: _audioLinks,
};

export const audioSelectionItem: AudioSelectionItem = {
  ...audio,
  songDetails: { status: SongStatusType.HOLD, title: 'title' },
};

export const lyrics: LyricsData = {
  guid: '1111',
  parent: '2222',
  createdBy: {
    userGuid: '3333',
    profileCard,
  },
  created: time,
  title: 'My lyrics',
};

export const _lyricsLinks: _LyricsLinks = {
  getLyricSheet: {
    href: '/get-lyric-sheet',
  },
  createLyricSheet: {
    href: '/create-lyric-sheet',
    method: 'POST',
  },
};

export const lyricSheet: LyricSheet2 = {
  guid: '1111',
  parent: '2222',
  createdBy: {
    userGuid: '3333',
    profileCard,
  },
  title: 'My lyrics',
  created: time,
  _links: {
    self: href,
    getLyricSheetPdf: href,
    connect: { href: href.href, token: 'token' },
  },
};

export const song: Song = {
  guid: 'SNG_song-guid',
  title: 'White Christmas',
  collaborators: [collaborator],
  keySignature: 'AFlatMajor',
  timeSignature: 'OneQuarter',
  location: {
    address: 'London',
  },
  explicit: true,
  notes: 'note',
  creationDate: {
    date: '2021-05-28',
  },
  tempo: 10,
  altTitle: 'alternative',
  duration: 120,
  language: 'en',
  created: time,
  updated: time,
  status: SongStatusType.HOLD,
  audio: [audio],
  createdBy: 'human#159',
  _links: _songLinks,
  lyrics: [lyrics],
  lyricSheet,
  entityType: EntityType.SONG,
  chat: {
    guid: '1234-2134-1234567890123-123456',
    status: 'READY',
  },
};

export const split: LatestSplit = {
  created: time,
  createdBy: {
    userGuid: 'user-guid',
    profileCard,
  },
  members: [],
  sequenceNumber: 1,
  songGuid: 'song-guid',
  updated: time,
  valid: true,
  _links: {
    self: href,
    acceptWorkSplit: href,
    getLatestWorkSplit: href,
    getLatestWorkSplitPdf: href,
  },
};

export const settings: Settings = {
  badge: {
    visible: true,
  },
};

export const country: Country = {
  countryCode: 'LT',
  name: 'Lithuania',
};

export const countryOption: Option = {
  value: 'LT',
  title: 'Lithuania',
};

export const countryDDL: FetchDDLResponse = {
  alpha2: {
    LT: {
      key: 'LT',
      name: 'Lithuania',
    },
  },
};

export const profileFormData: ProfileFormData = {
  firstName: 'Name',
  lastName: 'LastName',
  displayName: 'My display name',
  middleName: 'Middle name',
  address: {
    primaryAddress: 'address 1',
    city: 'kaunas',
  },
  country: {
    title: country.name,
    value: country.countryCode,
  },
  preferredIpi: null,
  preferredIpn: null,
  preferredIsni: null,
  privacySettings: { isSearchable: true },
  representatives: [],
};

export const contributionFormData: ContributionFormData = {
  contributor: null,
  name: 'name',
  className: ContributionClassName.ARTIST,
  artistRole: null,
  composerRole: null,
  productionRole: null,
  performerRole: null,
  performerRoleDetail: null,
  otherRole: '',
  artistIpn: '',
  composerIpi: '',
  producerIpn: '',
  performerIpn: '',
  artistIsni: '',
  composerIsni: '',
  producerIsni: '',
  performerIsni: '',
  detail: '',
  date: {
    date: new Date('2015-05-12'),
  },
  location: {
    name: 'location name',
    address: 'location address',
    country: null,
  },
};

export const profile: Profile = {
  guid: 'guid',
  firstName: 'Name',
  lastName: 'LastName',
  displayName: 'My display name',
  created: time,
  type: ProfileType.LEGAL,
  subject: 'subject-guid',
  initials: 'NL',
  updated: time,
  address: {
    countryCode: 'LT',
    primaryAddress: 'address 1',
    city: 'kaunas',
  },
  privacySettings: { isSearchable: true },
  _links: {
    listIpis: href,
    self: href,
    update: { href: 'me/PRF_USR_123', method: 'PATCH' },
    countryCodesAlpha2DDL: { href: 'country-ddl' },
    listIds: href,
    listIpns: href,
  },
};

export const profileListItem: ProfileItem = {
  guid: 'guid',
  firstName: 'Name',
  lastName: 'LastName',
  displayName: 'My display name',
  created: time,
  type: ProfileType.LEGAL,
  subject: 'subject-guid',
  initials: 'NL',
  address: {
    countryCode: 'LT',
    primaryAddress: 'address 1',
    city: 'kaunas',
  },
  privacySettings: { isSearchable: true },
  profileImages: [
    { name: ProfileImageSize.AVATAR_TINY, href: 'someimagelink' },
  ],
  updated: time,
};

export const _profileListLinks: _ProfileListLinks = {
  create: href,
  update: href,
  self: href,
  delete: href,
  profile: href,
};

export const _songsLinks: _SongsLinks = {
  self: href,
  create: href,
  song: href,
};

export const bootstrapServices: BootstrapServices = {
  user: {
    _links: {
      forgotPassword: href,
      self: href,
      passwordPolicy: href,
      signUp: href,
      signIn: href,
    },
  },
  songs: {
    _links: {
      listSongs: href,
      languageCodesAlpha2DDL: href,
      listLyrics: href,
      createLyric: href,
      self: href,
      songGenresDDL: href,
      songAudioTypesDDL: href,
      listSongAudio: href,
    },
  },
  contributions: {
    _links: {
      myContributions: href,
      contributionClassesAndRolesDDL: href,
    },
  },
  profiles: {
    _links: {
      countryCodesAlpha2DDL: href,
    },
  },
  'releases-2': {
    _links: {
      listLabels: href,
    },
  },
};

export const account: Account = {
  accountEmail: 'mail@test.com',
  displayName: 'John Doe',
  country: {
    name: 'United States',
    countryCode: 'US',
  },
  firstName: 'John',
  lastName: 'Doe',
  profile: {
    firstName: 'John',
    lastName: 'Doe',
    displayName: 'John Doe',
    initials: 'JD',
  },
  initials: 'JD',
  roles: [],
  userGuid: '123abc',
};

export const bootstrapPayload: BootstrapPayload = {
  services: bootstrapServices,
  account,
};

export const audioFormValidation: AudioFormValidationProperties = {
  originalFileName: { maxLength: 255 },
  title: { maxLength: 255 },
  remark: { maxLength: 255 },
  type: { default: 'Bounce' },
  fileSize: {
    minimum: 1,
    maximum: 5368709120,
  },
};

export const audioTypesDDL: AudioTypesDDL = {
  Bounce: {
    key: 'Bounce',
    name: 'Bounce',
  },
  Stem: {
    key: 'Stem',
    name: 'Stem',
  },
  Private: {
    key: 'Private',
    name: 'Private',
  },
};

export const societyAffiliation: SocietyAffiliation = {
  societyId: 74,
  acronym: 'SIAE',
  country: 'ITALY',
};

export const ipi: Ipi = {
  userGuid: 'zz4b5c55',
  ipiReference: '589918861',
  identityReference: 'bb4b51f8',
  ipiNameNumber: 589918861,
  created: time,
  updated: time,
  nameNumberType: 'PP',
  firstName: 'first-name',
  lastName: 'last-name',
  profile: {
    reference: '589918861',
    displayName: 'DAVID C',
    initials: 'DC',
  },
  prSocietyAffiliation: societyAffiliation,
  mrSocietyAffiliation: societyAffiliation,
  verified: true,
  _links: {
    deleteIpi: href,
  },
};

export const ipn: Ipn = {
  userGuid: 'zz4b5c55',
  ipnNumber: 589918861,
  created: time,
  updated: time,
  profile: {
    reference: '589918861',
    displayName: 'DAVID C',
    initials: 'DC',
  },
  cmoSocietyAffiliation: societyAffiliation,
  verified: true,
  _links: {
    updateIpn: href,
    deleteIpn: href,
  },
  ipnReference: 'ref:ipn',
  firstName: 'first-name',
  lastName: 'last-name',
};

export const songDDL: SongDDL = {
  dateAccuracy: {
    Exact: {
      key: 'Exact',
      name: 'Exact',
    },
    Approx: {
      key: 'Approx',
      name: 'Approx',
    },
  },
  genres: {
    DrumAndBass: {
      key: 'DrumAndBass',
      name: 'Drum & Bass',
    },
    Pop: {
      key: 'Pop',
      name: 'Pop',
    },
  },
  keySignatures: {
    AFlatMajor: {
      key: 'AFlatMajor',
      name: 'A♭ major',
    },
    AFlatMinor: {
      key: 'AFlatMinor',
      name: 'A♭ minor',
    },
  },
  statuses: {
    IN_CREATION: {
      key: 'IN_CREATION',
      name: 'In Creation',
    },
    PITCHABLE: {
      key: 'PITCHABLE',
      name: 'Pitchable',
    },
  },
  timeSignatures: {
    OneQuarter: {
      key: 'OneQuarter',
      name: '1/4',
    },
    TwoQuarters: {
      key: 'TwoQuarters',
      name: '2/4',
    },
  },
};

export const society: Society = {
  type: 'PRO',
  id: '23',
  created: {
    timestamp: 1606463954,
    iso: '2020-11-27T07:59:14.490Z',
  },
  updated: {
    timestamp: 1606463954,
    iso: '2020-11-27T07:59:14.490Z',
  },
  verification: {
    version: 2,
    enabled: true,
  },
  acronym: 'BUMA',
  country: 'NETHERLANDS',
};

export const societyV0: Society = {
  type: 'PRO',
  id: '22',
  created: {
    timestamp: 1606463954,
    iso: '2020-11-27T07:59:14.490Z',
  },
  updated: {
    timestamp: 1606463954,
    iso: '2020-11-27T07:59:14.490Z',
  },
  acronym: 'ASCAP',
  country: 'NETHERLANDS',
};

export const _societyLinks: _SocietyLinks = {
  addIpn: { ...href, allowedParameters: [] },
  addIpiV0: { ...href, allowedParameters: [] },
  addIpiV2: { ...href, allowedParameters: [] },
  addIpnV2: { ...href, allowedParameters: [] },
  initiateClaimSocietyRecords: { ...href },
};

export const _ipiListLinks: _IpiListLinks = {
  self: href,
  listSocieties: href,
  ipiSearchCreators: href,
  ipi: href,
  patch: href,
  associations: href,
};

export const _ipnListLinks: _IpnListLinks = {
  self: href,
  listSocieties: href,
};

export const _isniListLinks: _IsniListLinks = {
  self: href,
  createIsni: href,
};

export const ipiSearchCreatorOption: IpiSearchCreatorOption = {
  ipiNameNumber: 589558861,
  nameNumberType: 'PP',
  profile: {
    displayName: 'John Doe',
    initials: 'JD',
  },
  isCreator: true,
  lastName: 'Doe',
  firstName: 'John',
  mrSocietyAffiliations: [],
  prSocietyAffiliations: [],
};

export const searchableProfile: SearchableProfile = {
  guid: '111',
  subject: '222',
  initials: 'JD',
  displayName: 'John Doe',
  type: ProfileType.LEGAL,
  address: {
    countryCode: 'LT',
    city: 'Kaunas',
  },
};

export const contributionValidationSchema: ContributionValidationSchema = {
  name: { maxLength: 5, minLength: 1 },
};

export const credit: Credit = {
  title: 'My Song',
  roles: { Artist: [{ role: 'Featuring', guid: 'FeaturingGuid' }] },
  song: {
    status: SongStatusType.IN_CREATION,
    title: 'My Song',
  },
  addedBy: {
    userGuid: '123',
    profile: {
      guid: '456',
      displayName: 'Paris',
      initials: 'PR',
    },
  },
  guid: 'string',
  updatedAt: {
    timestamp: 1606463954,
    iso: '2020-11-27T07:59:14.490Z',
  },
  _links: {
    getDetails: {
      href: 'getDetails',
    },
  },
};
export const _creditListLinks: _CreditListLinks = {
  next: {
    href: '/next-credit',
  },
};

export const passwordPolicy: PasswordPolicy = {
  maximumLength: 99,
  minimumLength: 6,
  notSameAsCurrent: true,
  requireLowercase: true,
  requireNumbers: true,
  requireSpecialCharacters: true,
  requireUppercase: true,
  pattern: '.{6}',
};

export const notification: Notification = {
  sender: {
    profileImages: [{ href: 'image', name: ProfileImageSize.AVATAR_TINY }],
    initials: 'JD',
    displayName: 'Jane Doe',
  },
  body: 'John Doe invites you to best song ever to join as a collaborator.',
  guid: '123456',
  created: {
    iso: '2021-08-17T06:45:06.474Z',
    timestamp: 1629182706,
  },
  new: false,
  read: false,
  rel: '/href',
};

export const _inviteLinks: _InviteLinks = {
  transferInvite: href,
  respondToInvite: href,
};

export const invite: Invite = {
  inviter: {
    profileCard: {
      guid: 'profile-card-guid',
      subject: 'SUB_ADAs6a556asf8',
      displayName: 'display-name',
      initials: 'IN',
      profileImages: [{ href: 'image', name: ProfileImageSize.AVATAR_TINY }],
    },
  },
  body: 'John Doe invites you to best song ever to join as a collaborator.',
  guid: '123456',
  created: {
    iso: '2021-08-17T06:45:06.474Z',
    timestamp: 1629182706,
  },
  new: false,
  _links: _inviteLinks,
};

export const _notificationsListLinks: _NotificationListLinks = {
  next: {
    href: '/next-notifications',
  },
};

export const _invitesListLinks: _InvitesListLinks = {
  respondToInvite: href,
  next: {
    href: '/next-notifications',
  },
};

export const lyricValidationSchema: LyricValidationSchema = {
  title: {
    maxLength: 255,
    minLength: 1,
  },
  body: {
    maxLength: 20000,
    minLength: 0,
  },
};

export const contributionClassesDDL: ContributionClassRolesDDL = {
  Artist: {
    key: 'Artist',
    name: 'Artist',
    description: 'The principle performer on a record',
  },
  Songwriter: {
    key: 'Songwriter',
    name: 'Song Writer',
    description: 'The composer or arranger of the Song Work',
  },
  Production: {
    key: 'Production',
    name: 'Production',
    description: 'Producer, Engineer, Mixer, Mastering engineer',
  },
  Performer: {
    key: 'Performer',
    name: 'Performer',
    description: 'A Performer, the Musicians & Instruments played',
  },
};

export const contributionRolesDDL: ContributionClassRolesDDL = {
  With: {
    key: 'With',
    name: 'With',
    parent: 'Artist',
    description: 'description',
  },
  Primary: {
    key: 'Primary',
    name: 'Primary',
    parent: 'Composition',
    description: 'description',
  },
  Guitar: {
    key: 'Guitar',
    name: 'Guitar',
    parent: 'Prduction',
    description: 'description',
  },
};

export const contributionClassesAndRolesDDL: ContributionClassesAndRolesDDL = {
  classRoles: { ...contributionRolesDDL, ...contributionClassesDDL },
  classes: contributionClassesDDL,
  artistRoles: {},
  productionRoles: {},
  performanceVocals: {},
  performanceRoles: {},
  performanceInstruments: {},
  compositionRoles: {},
  performanceGroups: {},
};

export const ipiValidations: IpiValidations = {
  properties: {
    firstName: {
      maxLength: 255,
      minLength: 1,
    },
    lastName: {
      maxLength: 255,
      minLength: 1,
    },
    ipiNameNumber: {
      maximum: 10,
      minimum: 1,
    },
  },
  anyOf: [
    {
      required: ['firstName'],
    },
    {
      required: ['lastName'],
    },
  ],
};

export const ipnValidations: IpnValidations = {
  properties: {
    firstName: {
      maxLength: 255,
      minLength: 1,
    },
    lastName: {
      maxLength: 255,
      minLength: 1,
    },
    ipnNumber: {
      maximum: 10,
      minimum: 1,
    },
  },
  anyOf: [
    {
      required: ['firstName'],
    },
    {
      required: ['lastName'],
    },
  ],
};

export const version: Version = { guid: 'SNG_111', type: 'AlbumVersion' };

export const releaseSong: ReleaseSong = {
  songGuid: 'song123',
  snapshot: {
    title: 'Summer',
  },
  overrides: {},
  versions: [version],
};

export const release: Release = {
  guid: 'RLS_x4t87MLyLnY60ALGgbRII5_33',
  title: 'First release',
  type: ReleaseType.LABEL,
  created: time,
  updated: time,
  createBy: {
    userGuid: 'user123',
    profileCard,
  },
  songs: [releaseSong],
  _links: {
    createReleaseVersion: href,
    updateRelease: href,
    updateReleaseSongOverrides: href,
    exportRelease: href,
    getReleaseVersion: href,
    deleteReleaseVersion: href,
    deleteReleaseSong: href,
    moveReleaseVersion: href,
  },
};

export const releaseVersionMetadata: ReleaseVersionMetadata = {
  guid: 'VRS_qDDVi3',
  songGuid: 'SNG_WqfWySKxP61AQ02ZDgrT1U_fd',
  songTitle: 'a1',
  releaseGuid: 'RLS_xsCzoeyV4re7PxA59EmkKd_7f',
  type: 'ACappellaVersion',
  versionTitle: 'Version title',
  createdBy: {
    userGuid: 'USR_BTJkToCFNEoRiMcbWratbo_6f',
  },
  created: time,
  updated: time,
  songSynced: time,
  contributionsSynced: time,
  lyricsSynced: time,
  splitSynced: time,
};

export const releaseVersionSong: ReleaseVersionSong = {
  altTitle: 'alt-title',
  displayArtistName: 'artist-name',
  duration: 100,
  explicit: false,
  genres: [],
  language: 'en',
  keySignature: 'AFlatMajor',
  timeSignature: 'OneQuarter',
  location: {
    address: 'London',
  },
  tempo: 10,
  title: 'title',
};

export const releaseVersion: ReleaseVersion = {
  metadata: releaseVersionMetadata,
  contributions: [],
  song: {
    overrides: {},
    snapshot: releaseVersionSong,
    snapshotUpdated: time,
    songGuid: 'song-guid',
    updated: time,
    versionGuid: 'version-guid',
  },
  _links: {
    updateReleaseVersionAudio: href,
    syncReleaseVersion: href,
    updateReleaseVersionContribution: href,
    updateReleaseVersionMetadata: href,
    updateReleaseVersionSong: href,
    listAudioBySong: href,
    replacePrimaryAudio: { href: '/replace', method: 'POST' },
  },
};

export const soundCloudVersion: SoundCloudVersion = {
  guid: 'VRS_67BlUFMn9CQzc8UNYAZ67b_0c',
  type: 'AlbumVersion',
  primaryAudioGuid: 'AUD_eRqOWApSy7LtwFrZ0DiP0q_1b',
  originalAudioGuid: 'AUD_eRqOWApSy7LtwFrZ0DiP0q_1b',
  title: 'ievan polkka (cover by MALKA).mp3',
  updated: {
    timestamp: 1650552020,
    iso: '2022-04-21T14:40:20.208Z',
  },
  song: {
    guid: 'SNG_7DgHtfokgwMcSH8cmdQrxH_ce',
    songGuid: 'SNG_7DgHtfokgwMcSH8cmdQrxH_ce',
    overrides: {},
    title: 'FINNISH folk song (Ievan polkka) 2022 Feb 24',
  },
};

export const updateReleaseSongTitleValidations: UpdateReleaseSongTitleValidations = {
  title: {
    maxLength: 255,
    minLength: 1,
  },
};

export const updateReleaseValidations: UpdateReleaseValidations = {
  title: {
    maxLength: 255,
    minLength: 1,
  },
};

export const updateReleaseVersionValidations: UpdateReleaseVersionValidations = {
  versionTitle: stringValidation,
  description: stringValidation,
};

export const updateVersionSongValidations: UpdateVersionSongValidations = {
  altTitle: stringValidation,
  displayArtistName: stringValidation,
  duration: numberValidation,
  explicit: true,
  genres: {
    items: {
      properties: {
        genre: {
          enum: ['enum'],
        },
      },
    },
  },
  keySignature: {
    enum: ['AFlatMajor'],
  },
  language: {
    enum: ['en'],
  },
  location: {
    properties: {
      address: stringValidation,
    },
  },
  tempo: numberValidation,
  timeSignature: {
    enum: ['7/8'],
  },
};

export const signUpFormData: SignUpData = {
  email: 'fredrick@test.com',
  password: 'bonjovisignal',
  firstName: 'Fredrick',
  lastName: 'Banner',
  displayName: 'Fredrick Banner',
  city: 'athens',
  country: {
    title: 'Lithuania',
    value: 'LT',
  },
};

export const profileAddress: ProfileAddress = {
  countryCode: 'GB',
  primaryAddress: 'River 1',
  secondaryAddress: 'River 1A',
  city: 'London',
  stateProvinceRegion: '',
  zipCode: '1234',
};

export const searchProfilesValidationProperties: SearchProfilesValidationProperties = {
  limit: {
    default: 0,
    maximum: 50,
    minimum: 0,
  },
  offset: {
    default: 0,
    minimum: 0,
  },
  search: {
    maxLength: 100,
    minLength: 1,
  },
};

export const isni: Isni = {
  userGuid: 'zz4b5c55',
  isniReference: 'bb4b51f8',
  isni: '123456789',
  created: time,
  updated: time,
  firstName: 'first-name',
  lastName: 'last-name',
  profile: {
    reference: '589918861',
    displayName: 'DAVID C',
    initials: 'DC',
  },
  verified: true,
  default: false,
  _links: {
    deleteIsni: href,
    updateIsni: href,
  },
};

export const connection: Connection = {
  guid: 'guid',
  name: 'name',
  userGuid: 'userGuid',
  providerId: 'SoundCloud',
  created: time,
  updated: time,
  _links: {
    disconnect: {
      href: 'https://api.example.com/base/guid',
      method: 'DELETE',
    },
  },
};

export const representative: Representative = {
  firstName: 'Craig',
  lastName: 'Ferguson',
  company: 'GMI Publishing',
  role: 'AR',
  email: 'craig.ferguson@mail.com',
};

export const subscription: Subscription = {
  _links: {
    self: href,
    listSubscriptionsTiers: href,
    manageSubscription: href,
    subscriptionTiersDDL: href,
  },
  hasSubscription: false,
};

export const pricingPlan: PricingPlan = {
  currency: 'EUR',
  id: 'pricing-id',
  interval: 'month',
  isDefaultPrice: true,
  price: 10,
};

export const tier: Tier = {
  description: 'description',
  id: 'some-id',
  images: [],
  pricingPlans: [pricingPlan],
  sortOrder: 'asc',
  title: 'title',
  tier: '913e8b6f-fb7d-4948-9ef1-15471e1cd599',
  limitBytes: 53687091200,
};

export const subscriptionTiersDDL: DDL = {
  '913e8b6f-fb7d-4948-9ef1-15471e1cd599': {
    key: '913e8b6f-fb7d-4948-9ef1-15471e1cd599',
    name: 'TestCreator',
  },
  'dddfdd32-1fb1-4322-a9de-e811f1b4964e': {
    key: 'dddfdd32-1fb1-4322-a9de-e811f1b4964e',
    name: 'TestPro',
  },
};

export const tierList: Tier[] = [
  {
    id: 'prod_MEB8FmEHwvZNjR',
    tier: '913e8b6f-fb7d-4948-9ef1-15471e1cd599',
    title: 'Chris creator (multi currency)',
    description:
      'All the collaborative and creator features in Free + 50 GB storage',
    images: [],
    sortOrder: 'asc',
    pricingPlans: [
      {
        id: '',
        currency: 'eur',
        interval: 'year',
        price: 1129,
        isDefaultPrice: false,
      },
      {
        id: 'price_1LVim1KDTpLPN8S4DB2hHTMV',
        currency: 'gbp',
        interval: 'year',
        price: 949,
        isDefaultPrice: false,
      },
      {
        id: 'price_1LVim1KDTpLPN8S4DB2hHTMV',
        currency: 'usd',
        interval: 'year',
        price: 1159,
        isDefaultPrice: false,
      },
      {
        id: 'price_1LVim1KDTpLPN8S4PzEDRCZf',
        currency: 'eur',
        interval: 'month',
        price: 99,
        isDefaultPrice: true,
      },
      {
        id: 'price_1LVim1KDTpLPN8S4PzEDRCZf',
        currency: 'gbp',
        interval: 'month',
        price: 99,
        isDefaultPrice: true,
      },
      {
        id: 'price_1LVim1KDTpLPN8S4PzEDRCZf',
        currency: 'usd',
        interval: 'month',
        price: 99,
        isDefaultPrice: true,
      },
    ],
    nextTier: 'dddfdd32-1fb1-4322-a9de-e811f1b4964e',
    limitBytes: 53687091200,
  },
  {
    id: 'prod_MEBC5BZid54ZvF',
    tier: 'dddfdd32-1fb1-4322-a9de-e811f1b4964e',
    title: 'Chris Pro creator (multi currency)',
    description: '',
    images: [],
    sortOrder: 'asc',
    pricingPlans: [
      {
        id: 'price_1LViqFKDTpLPN8S49k4iVtIM',
        currency: 'eur',
        interval: 'year',
        price: 3500,
        isDefaultPrice: false,
      },
      {
        id: 'price_1LViqFKDTpLPN8S49k4iVtIM',
        currency: 'gbp',
        interval: 'year',
        price: 3000,
        isDefaultPrice: false,
      },
      {
        id: 'price_1LViqFKDTpLPN8S49k4iVtIM',
        currency: 'usd',
        interval: 'year',
        price: 3700,
        isDefaultPrice: false,
      },
      {
        id: 'price_1LViqFKDTpLPN8S425T9uOUC',
        currency: 'eur',
        interval: 'month',
        price: 369,
        isDefaultPrice: true,
      },
      {
        id: 'price_1LViqFKDTpLPN8S425T9uOUC',
        currency: 'gbp',
        interval: 'month',
        price: 311,
        isDefaultPrice: true,
      },
      {
        id: 'price_1LViqFKDTpLPN8S425T9uOUC',
        currency: 'usd',
        interval: 'month',
        price: 379,
        isDefaultPrice: true,
      },
    ],
    previousTier: 'dddfdd32-1fb1-4322-a9de-e811f1b4964e',
    limitBytes: 214748364800,
  },
];

export const audioPlayerAudioInstance: AudioPlayerAudioInstance = {
  audioGuid: 'audio-guid',
  audioSrc: 'audio-src',
  audioTitle: 'audio-title',
  duration: 10000,
  loading: false,
  isError: false,
  note: 'audio-note',
  parentGuid: 'parent-guid',
  songStatus: SongStatusType.HOLD,
  songTitle: 'song-title',
  waveformSrc: 'waveform-src',
};

export const playlistDetails: PlaylistDetails = {
  description: 'playlist-description',
  guid: 'playlist-guid',
  title: 'playlist-title',
  author: 'playlist-author',
};

export const playlistAudio: PlaylistAudio = {
  guid: 'PLA_123',
  playlistGuid: 'PLS_123',
  audio: {
    guid: 'AUD_123',
    title: 'Stay With me - final.wav',
    duration: 121515,
  },
  song: {
    guid: 'SNG_123',
    title: 'Stay With Me',
  },
  note:
    'Anyone who wants a career in music needs to know how to get paid. But there’s a whole world of complicated acronyms and codes to know, and which publishers, distributors, publishing rights organisations and labels need what information.\n' +
    '\n' +
    'In our video below, shot at a Songwriting Camp at the prestigious Palma Music Studios, Session Studio’s founder and producer Niclas Molinder, talks about the five essential music identifiers you need to know to ensure you are getting the proper music credits you need in order to get paid.',
  created: time,
};

export const playlist: Playlist = {
  guid: 'PLS_123',
  title: 'Playlist one',
  description: 'description',
  playlistAudios: [],
  images: [],
  createdBy: {
    userGuid: 'USR_111',
    profileCard,
  },
  _links: {
    getPlaylist: {
      href: 'playlist',
      method: 'GET',
    },
    createPlaylistAudio: {
      href: 'create-playlist',
      method: 'POST',
    },
    deletePlaylistAudio: {
      href: 'delete-playlist-audio',
      method: 'DELETE',
    },
    patchPlaylist: {
      href: 'patch-playlist',
      method: 'PATCH',
    },
    movePlaylistAudio: {
      href: 'move-audio',
      method: 'POST',
    },
    updatePlaylistAudio: {
      href: 'update-audio',
      method: 'PATCH',
    },
    uploadPlaylistImage: {
      href: 'upload-image',
      method: 'POST',
    },
    deletePlaylistImage: {
      href: 'delete-image',
      method: 'DELETE',
    },
  },
};

export const playlistListItem: PlaylistsListItem = {
  guid: 'PLS_123',
  title: 'Playlist one',
  created: time,
  updated: time,
  audioCount: 2,
  images: [],
};

export const chatMessage: MessageType | ChatMessageItem = {
  guid: 'MSG_123',
  refId: 'REF_123',
  text: 'New message text',
  needRetry: false,
  updated: time,
  created: time,
  createdBy: {
    userGuid: 'USR_123',
  },
  user: { guid: 'USR_123' } as ProfileCard,
};

export const chatChannelListItem: ChatChannelListItem = {
  guid: '1',
  icon: '',
  status: SongStatusType.IN_CREATION,
  latestMessage: {
    guid: '1',
    text: 'msg',
    updated: time,
    createdBy: {
      profileCard: profile,
      userGuid: '1',
    },
    type: 'unread',
  },
  created: time,
  updated: time,
  title: 'sng',
  unreadMessageCount: 4,
  parentGuid: 'SNG_1',
};
